import { useTenantConfig } from '../../context/TenantConfigContext'
import FooterCenteredLight from './FooterCenteredLight'
import FooterColumnsLight from './FooterColumnsLight'
import FooterCenteredDark from './FooterCenteredDark'
import FooterColumnsDark from './FooterColumnsDark'

const FOOTER_REGISTRY = {
  'footer-centered-light': FooterCenteredLight,
  'footer-columns-light': FooterColumnsLight,
  'footer-centered-dark': FooterCenteredDark,
  'footer-columns-dark': FooterColumnsDark,
  'footer-default': FooterCenteredLight,
  FOOTER_DEFAULT: FooterCenteredLight,
  FOOTER_SIMPLE: FooterCenteredLight,
  FOOTER_CENTERED_LIGHT: FooterCenteredLight,
  FOOTER_CENTERED_DARK: FooterCenteredDark,
  FOOTER_COLUMNS: FooterColumnsLight,
  FOOTER_COLUMNS_LIGHT: FooterColumnsLight,
  FOOTER_COLUMNS_DARK: FooterColumnsDark,
  default: FooterCenteredLight,
}

function DynamicFooter() {
  const { config, getComponentKey } = useTenantConfig()
  const key = getComponentKey('footer')
  const FooterComponent = FOOTER_REGISTRY[key] ?? FooterCenteredLight

  return <FooterComponent config={config} />
}

export default DynamicFooter
